import React from 'react';
import { Icon } from '@placer-ui/components';
import type { SupportRequestType } from 'features/offline-reports/support-requests/components/support-requests-modals/types';
import { getFeatureFlags } from 'core/flow-control';

interface CardConfig {
    title: string;
    description: string;
    icon: JSX.Element;
    onClick?: () => void;
    type: SupportRequestType;
    testId: string;
}

const ICON_SIZE = 48;
const ICON_COLOR = 'brand';
export const requestsCardsConfig: () => CardConfig[] = () => {
    const { enable_market_request_ff } = getFeatureFlags();

    return [
        {
            title: 'Property',
            testId: 'property-request',
            description: 'Specify one or more properties',
            icon: (
                <Icon type="Property" color={ICON_COLOR} size={ICON_SIZE} allowHoverState={false} />
            ),
            type: 'property',
        },
        {
            title: 'Traffic Pin',
            testId: 'traffic-pin-request',
            description: 'Provide coordinates to measure passerby traffic',
            icon: (
                <Icon
                    type="TrafficPin"
                    color={ICON_COLOR}
                    size={ICON_SIZE}
                    allowHoverState={false}
                />
            ),
            type: 'trafficPin',
        },
        {
            title: 'Chain',
            testId: 'chain-request',
            description: 'Request chain addition or enacted coverage',
            icon: <Icon type="Chain" color={ICON_COLOR} size={ICON_SIZE} allowHoverState={false} />,
            type: 'chain',
        },
        enable_market_request_ff
            ? {
                  title: 'Market',
                  testId: 'market-request',
                  description: 'Request custom polygon',
                  icon: (
                      <Icon
                          type="Market"
                          color={ICON_COLOR}
                          size={ICON_SIZE}
                          allowHoverState={false}
                      />
                  ),
                  type: 'market',
              }
            : {
                  title: 'Region',
                  testId: 'region-request',
                  description: 'Request a large polygon',
                  icon: (
                      <Icon
                          type="MapPinArea"
                          color={ICON_COLOR}
                          size={ICON_SIZE}
                          allowHoverState={false}
                      />
                  ),
                  type: 'region',
              },
    ];
};
